import ProductSelector from './PeriodSelector'

export default ProductSelector
